import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    systemCheckOuterBox: {
      overflow: 'hidden',
      borderRadius: '16px',
      background: 'white',
      height: '879px',
      [theme.breakpoints.down('lg')]: {
        height: '1730px'
      }
    },
    systemCheckInnerBox: {
      width: '100%',
      margin: '0px'
    },
    systemCheckHeaderContainer: {
      padding: '0px 0px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        minHeight: '180px',
        maxHeight: '225px'
      }
    },
    systemCheckHeaderBox: {
      flex: 'none',
      background: 'transparent',
      padding: '24px 56px 0px 56px',
      margin: '0px 0px 56px 0px',
      minWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        padding: '24px 56px 0px 70px',
        margin: '0px 0px 0px 0px'
      }
    },
    systemCheckHeader: {
      fontFamily: 'Poppins, sans-serif',
      margin: '0px',
      fontSize: '56px',
      fontWeight: 600,
      [theme.breakpoints.down('lg')]: {
        fontSize: '50px'
      }
    },
    systemCheckSubHeader: {
      fontFamily: 'Poppins, sans-serif',
      margin: '0px',
      fontSize: '20px'
    },
    systemCheckDeviceInnerContainer: {
      display: 'flex'
    },
    systemCheckLandscapeContainer: {
      width: '100%',
      padding: '0 100px 48px',
      margin: '0px',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    systemCheckPortraitContainer: {
      display: 'none',
      padding: '0 80px 32px',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      [theme.breakpoints.down('lg')]: {
        display: 'flex'
      }
    },
    systemCheckButtonsContainer: {
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '25px 0 0 0'
    },
    systemCheckHardwareDevices: {
      width: '365px',
      flex: 'none',
      height: '383px',
      background: 'transparent'
    },
    statusChip: {
      fontSize: 15,
      fontWeight: 600,
      height: '45px',
      lineHeight: 1.5,
      borderWidth: '4px',
      padding: '0px 16px',
      borderRadius: '50px',
      backgroundColor: 'transparent',
      minWidth: '96px',
      borderStyle: 'solid',
      '& .MuiChip-label': {
        padding: 0
      }
    }
  })
);
